import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import App from './components/App'
import './scss-style.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import '@fortawesome/fontawesome-free/js/all.min.js'
import { createReduxStore } from './store'
import { AutoRemoteSync } from './modules/common/withPortalAutoRemoteSync'
import { ToastContainer } from 'react-toastify';
// import registerServiceWorker from './registerServiceWorker'


const store = createReduxStore()

ReactDOM.render(
  <Provider store={store}>
    <AutoRemoteSync store={store}>
      <App />
      <ToastContainer />
    </AutoRemoteSync>
  </Provider>,
  document.getElementById('root'),
)
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js